












import Vue from 'vue'
import ProductCard from '@/common/components/productCard/ProductCard.vue'
import ProductCardGender from '@/common/components/productCard/ProductCardGender.vue'

export default Vue.extend({
  components: {
    ProductCard,
    ProductCardGender
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    productUrl(): string {
      return this.product.url
    }
  }
})
